import { render, staticRenderFns } from "./SupplierFactors.vue?vue&type=template&id=054be2ea&"
import script from "./SupplierFactors.vue?vue&type=script&lang=js&"
export * from "./SupplierFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports